import { ThemeSizingConfiguration } from "../../types/theme";

export const THEME_SIZING: ThemeSizingConfiguration = {
  x0: '0px',
  x0_0_1: '2px',
  x0_1: '4px',
  x1: '8px',
  x1_1: '12px',
  x1_2: '14px',
  x2: '16px',
  x2_1: '20px',
  x3: '24px',
  x4: '32px',
  x5: '40px',
  x6: '48px',
  x7: '56px',
  x8: '64px',
  x9: '72px',
  x10: '80px',
  x11: '88px',
  x12: '96px',
  x13: '104px',
}